import React, { useCallback } from 'react';
import { Typography, Box } from '@mui/material';
import { Button } from '@ui/buttons';
import { useNavigate } from 'react-router-dom';

export const Maintenance: React.FC = () => {
  const navigate = useNavigate();

  const navigateToHome = useCallback(() => {
    navigate('/');
  }, [navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: '2rem',
      }}
    >
      <Typography variant="h4">App is under maintenance</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '.5rem',
        }}
      >
        <Typography>
          We are currently performing maintenance on the application.
        </Typography>
        <Typography>
          Please try again in a few minutes. We apologize for any inconvenience
          this may cause.
        </Typography>
      </Box>
      <Button variant="outlined" onClick={navigateToHome}>
        Try again
      </Button>
    </Box>
  );
};
